exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".json-viewer{position:relative}.json-viewer textarea{font-family:Fira Mono,monospace}.json-viewer .warning{position:absolute;right:20px;top:0;color:red;font-size:19px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ceaaf16","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/ui/JsonViewer.vue
// module id = gIYy
// module chunks = 0 1 2